import logging from 'node-logging-js';
import jsb from 'node-jsb';

class Stage {
    constructor(element, options) {
        logging.applyLogging(this, 'Stage');
        this.logDebug('options:', options);
        this.element = element;

        this.playBtn = this.element.querySelector('.js-play');
        this.video = this.element.querySelector('.js-video');

        this.initializeEventListeners();
    }

    initializeEventListeners() {

        this.video.addEventListener('ended', () => {
            this.element.classList.remove('is-playing');
        });

        this.playBtn.addEventListener('click', () => {
            if(this.element.classList.contains('is-playing')) {
                this.element.classList.remove('is-playing');
                this.video.pause();
            } else {
                this.element.classList.add('is-playing');
                this.video.play();
            }
        });
    }
}

jsb.registerHandler('Stage', Stage);
export default Stage;